<template>
    <div class="message" ref="message" :style="messageStyle">
        <p-header :title="title"/>
        <div class="tip" v-if="!isProcessing">
            任務已結束，如有任何問題歡迎聯繫客服。
        </div>
        <div class="order" v-if="order.id" @click="goToOrder">
            <div class="location" v-if="order.locations.length">
                {{ order.locations[0].alias || order.locations[0].alias.road }}
            </div>
            <div class="content">
                <div class="title">
                    任務＃{{ order.id }}
                    <div class="status">{{ orderStatusText }}</div>
                </div>
                <div class="action">
                    查看
                    <img src="@/assets/img/next-white.svg">
                </div>
            </div>
        </div>
        <div class="chat-list" @scroll="chatListScroll" ref="messageList">
            <div class="two-one-day" v-if="isLastPage">
                - 所有聊天記錄僅保留 21 天 -
            </div>
            <chat-message v-for="message in reverseMessage" :message="message" :chat-id="orderId" :key="message.isNotSend ? 'not-' + message.notSendId : message.id" :ref="'chat-' + message.id" @reSendMessage="reSendMessage"/>
        </div>
        <chat-input v-if="isProcessing" @pushMessage="pushMessage"/>
    </div>
</template>

<script>
    import { getOrderMessage } from '../apis';
    import { mapGetters, mapActions } from 'vuex';
    import Header from "./components/Header";
    import ChatMessage from "./components/chat/ChatMessage";
    import ChatInput from "./components/chat/ChatInput";
    import * as R from 'ramda';

    export default {
        name: "Message",
        components: {
            'p-header': Header,
            'chat-message': ChatMessage,
            'chat-input': ChatInput,
        },
        data() {
            return {
                topPadding: 0,
                orderId: 0,
                meta: {
                    current_page: 0,
                    last_page: 1,
                    total: 0,
                },
                isLoading: false,
                previousRoute: {
                    name: null
                },
                firstScrollUnreadMessage: false,
            }
        },
        computed: {
            title() {
                return '#' + this.order.id + ' 騎士';
            },
            reverseMessage() {
                let rMessages = this.messages.filter((message, index, messages) => {
                    return message.isNotSend || messages.findIndex(m => m.id === message.id) === index;
                })
                return rMessages.reverse();
            },
            messageStyle() {
                return {
                    'height': 'calc((var(--vh, 1vh) * 100) - ' + this.topPadding + 'px)',
                }
            },
            isLastPage() {
                return this.meta.current_page === this.meta.last_page;
            },
            orderStatusText() {
                if (this.isWaitGoLocation) return '已預約';
                if (this.isProcessing) return '執行中';
                if (this.isCancel) return '已取消';
                if (this.isDone) return '已完成';

                return '確認中';
            },
            isProcessing() {
                return this.order.status === 'processing';
            },
            isWaitGoLocation() {
                return this.order.status === 'processing' && this.order.reserved_at && ! this.order.locations[0].arrived_at;
            },
            isDone() {
                return this.order.status === 'done';
            },
            isCancel() {
                return ['cancel', 'revoke', 'abstention'].indexOf(this.order.status) >= 0;
            },
            order() {
                return this.orderById(this.orderId) || {
                    id: 0,
                };
            },
            ...mapGetters(['orderById', 'messages', 'user']),
        },
        methods: {
            goToOrder() {
                if (this.previousRoute.name === 'timeline' && this.previousRoute.params.id == this.orderId) {
                    this.$router.back();
                    return;
                }

                this.$router.push({
                    name: 'timeline',
                    params: {
                        id: this.order.id,
                    }
                });
            },
            chatListScroll(event) {
                if (event.target.scrollTop > 0) return;
                if (this.isLoading) return;
                if (this.meta.current_page === this.meta.last_page) return;

                this.loadMessages();
            },
            loadMessages() {
                let payload = {
                    id: this.orderId,
                    data: {
                        page: this.meta.current_page + 1,
                    }
                }

                this.isLoading = true;
                getOrderMessage(payload).then(res => {
                    let scrollMessage = null;
                    if (this.reverseMessage.length) {
                        scrollMessage = this.reverseMessage[0]
                    }

                    this.meta = res.data.meta;
                    let newMsg = res.data.data;
                    if (this.meta.current_page === 1) {
                        let index = R.findLastIndex((m) => !m.read_at && m.user_id != this.user.id, newMsg);
                        if (index >= 0) {
                            newMsg.splice(index + 1, 0, {
                                id: -1,
                                is_self: false,
                                count: index + 1,
                            });
                        }
                    }

                    this.setMessages(this.messages.concat(newMsg));
                    let unreadIndex = this.reverseMessage.findIndex((m) => m.id === -1);
                    if (unreadIndex > -1) {
                        this.updateView(-1);
                    } else if (res.data.data.length > 0) {
                        this.updateView(scrollMessage ? scrollMessage.id : res.data.data[0].id);
                    }

                    this.getUnreadMessages().then(() => {
                        this.$nextTick(() => {
                            if (this.$refs.message) this.topPadding = this.$refs.message.offsetTop;
                        });
                    });
                }).finally(() => {
                    this.isLoading = false;
                });
            },
            pushMessage(message) {
                this.setMessages([message].concat(this.messages.filter(m => m.id !== -1)));
                this.updateView(message.id);
            },
            reSendMessage(data) {
                let notSendId = data['notSendId'];
                let message = data['message'];
                this.setMessages([message].concat(this.messages.filter(m => m.id !== -1 && m.notSendId !== notSendId)));
            },
            updateView(id) {
                this.$nextTick(() => {
                    this.$refs['chat-' + id][0].$el.scrollIntoView(false);
                    if ((this.$refs['chat-' + id][0].$el.getBoundingClientRect().top - this.$refs.messageList.getBoundingClientRect().top) > (this.$refs.messageList.getBoundingClientRect().height / 2)) {
                        this.$refs.messageList.scrollBy(0, (this.$refs.messageList.getBoundingClientRect().height / 2));
                    }
                    window.scrollBy(0, window.innerHeight);
                });
            },
            setVh() {
                this.$nextTick(() => {
                    let vh = window.innerHeight * 0.01;
                    document.documentElement.style.setProperty('--vh', `${vh}px`);
                    setTimeout(() => {
                        let vh = window.innerHeight * 0.01;
                        document.documentElement.style.setProperty('--vh', `${vh}px`);
                    }, 500);
                });
            },
            init() {
                this.meta = {
                    current_page: 0,
                    last_page: 1,
                    total: 0,
                };
                this.setMessages([]);
                this.firstScrollUnreadMessage = false;
                this.loadMessages();

            },
            ...mapActions(['getOrder', 'setMessages', 'getUnreadMessages'])
        },
        created() {
            this.setVh();
            window.addEventListener('resize', this.setVh);
            this.orderId = this.$route.params.id;
            this.init();
            this.getOrder(this.orderId).catch(() => {
                this.$router.back();
            });
            document.addEventListener('reloadEvent', this.init);
        },
        destroyed() {
            window.removeEventListener('resize', this.setVh);
            document.removeEventListener('reloadEvent', this.init);
        },
        updated() {
            if (this.$refs.message) this.topPadding = this.$refs.message.offsetTop;
        },
        beforeRouteEnter(to, from, next) {
            next(vm => vm.previousRoute = from);
        },
        watch: {
            reverseMessage() {
                if (!this.$refs.messageList) return;
                if (this.reverseMessage.length < 1) return;
                if (!this.firstScrollUnreadMessage) {
                    this.firstScrollUnreadMessage = true;
                    return;
                }

                if ((this.$refs.messageList.scrollHeight - (this.$refs.messageList.scrollTop + this.$refs.messageList.getBoundingClientRect().height)) < 40) {
                    this.updateView(this.reverseMessage[this.reverseMessage.length - 1].id);
                }
            }
        }
    }
</script>

<style lang="scss" scoped>
    .message {
        display: flex;
        flex-direction: column;

        .order {
            margin: 15px;
            border-radius: 5px;
            background-color: #4A4A4A;
            box-shadow: 0 0 3px 0 rgba(51,153,51,0.35);
            color: #FFFFFF;
            font-size: 14px;
            letter-spacing: 0;
            line-height: 20px;
            text-align: left;
            padding: 15px;
            cursor: pointer;
            user-select: none;

            .content {
                margin-top: 5px;
                display: flex;
                justify-content: space-between;

                .title {
                    display: flex;
                    .status {
                        margin-left: 5px;
                        font-size: 13px;
                        color: #4fe34f;
                    }
                }

                .action {
                    display: flex;
                }
            }
        }

        .tip {
            background-color: #9B9B9B;
            padding: 15px;
            color: #FFFFFF;
            font-size: 16px;
            font-weight: 500;
            text-align: left;
        }

        .two-one-day {
            color: #9b9b9b;
        }

        .chat-list {
            display: flex;
            flex-direction: column;
            flex: 1;
            overflow: scroll;

            :first-child {
                margin-top: auto !important;
            }
        }
    }
</style>